// 封装一个公共的 HTTP 请求类
import BaseService from "@/api/base";

class UserService extends BaseService {
    // 基础的 API 地址
    private login_path = "/1password/api/v1/user/login"
    private logout_path = "/1password/api/v1/user/logout"
    private get_principal_path = "/1password/api/v1/user/get_principal"
    private register_path = "/1password/api/v1/user/register"
    private find_password_path = "/1password/api/v1/user/find_password"
    private check_name_path = "/1password/api/v1/user/check_username"
    private check_name_and_mnemonic_path = "/1password/api/v1/user/check_username_and_mnemonic"
    private lock_screen_path = "/1password/api/v1/user/lock_screen"
    private unlock_screen_path = "/1password/api/v1/user/unlock_screen"
    private update_info_path = "/1password/api/v1/user/update_info"
    private change_password_path = "/1password/api/v1/user/change_password"

    // 封装 GET 请求方法
    public async login(data: any = {}): Promise<any> {
        return await this.postFetchData(this.login_path, data);
    }
    public async logout(): Promise<any> {
        return await this.postFetchData(this.logout_path, {});
    }

    public async register(data: any = {}): Promise<any> {
        return await this.postFetchData(this.register_path, data);
    }

    public async findPassword(data: any = {}): Promise<any> {
        return await this.postFetchData(this.find_password_path, data);
    }

    public async checkName(query: any = {}): Promise<any> {
        return await this.getFetchData(this.check_name_path,query);
    }

    public async checkNameAndMnemonic(query: any = {}): Promise<any> {
        return await this.getFetchData(this.check_name_and_mnemonic_path ,query);
    }

    public async getPrincipal(query: any = {}): Promise<any> {
        return await this.getFetchData(this.get_principal_path ,query);
    }

    public async lockScreen(data: any = {}): Promise<any> {
        return await this.postFetchData(this.lock_screen_path, data);
    }

    public async unlockScreen(data: any = {}): Promise<any> {
        return await this.postFetchData(this.unlock_screen_path, data);
    }

    public async updateInfo(data: any = {}): Promise<any> {
        return await this.postFetchData(this.update_info_path, data);
    }

    public async changePassword(data: any = {}): Promise<any> {
        return await this.postFetchData(this.change_password_path, data);
    }


}

export default UserService;
